import React, {useEffect, useState} from 'react';
import '../../styles.scss'
import {Link} from "react-router-dom";
import axios from "axios";


const Catalog = (props) => {
    const [story, setStory] = useState(null)
    const URL_PREFIX = 'http://kitap.alsu.tatar/'

    useEffect(()=>{
        axios.get(URL_PREFIX + 'api/karaoke/list').then((response)=>{
            console.log(response.data);
            setStory(response.data.message)
        })
    }, [])

    return (
        <>
            {story && (
                <div className={'inner-container column justify-center align-center'} >
                    <div className={'column'} style={{maxWidth: 983}}>
                        {/*<img src={require('../../assets/bottomLeft.png')} width={150} style={{position: 'fixed', bottom: 0, left: 0}} />*/}
                        {/*<img src={require('../../assets/topRight.png')} width={150} style={{position: 'fixed', top: 30, right: 0}} />*/}
                        <div>
                            <p className={'heading text__white'}>АЛСУ</p>
                            <p className={'regular-text-400 text__white'}>
                                Алсу – татар телен популярлаштыру һәм үстерү максатыннан, классик татар әсәрләренә нигезләнеп, кече яшьтәге мәктәп балалары өчен эшләнгән уникаль проект. Әлеге интерактив визуаль сайтта укучы игътибарына аудиокитаплар тәкъдим ителә. Төймәгә басып, әсәр текстындагы аңлашылмаган сүзләрнең мәгънәләре белән дә танышырга мөмкин.
                            </p>
                        </div>
                        <div className={'row justify-space-between pt-5 pb-5'} style={{flexWrap: 'wrap'}}>
                            {story.map((item, idx)=>(
                                <Link to={{pathname: '/module/'+idx, params: {stories: story, current: idx}}} style={{width: '43.5%',  backgroundColor: '#fff', marginBottom: 50, position: 'relative'}}>
                                    <img src={URL_PREFIX + item.cover} style={{objectFit: 'cover', width: '100%'}}/>
                                    <div className={'pl-4'} style={{textAlign: "left"}}>
                                        <p style={{fontWeight: 400, fontSize: 16}}>{item.author}</p>
                                        <p style={{fontWeight: 700, fontSize: 24}}>{item.title}</p>
                                    </div>
                                </Link>
                            ))}

                        </div>
                    </div>
                </div>
            )}
        </>
    )
};

export default Catalog;
